import { render, staticRenderFns } from "./ModalEstorno.vue?vue&type=template&id=46c7b56c"
import script from "./ModalEstorno.vue?vue&type=script&lang=js"
export * from "./ModalEstorno.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports